import { fetcher } from "helpers/fetcher";

import { TGetStaffBasicInfoRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffBasicInfo = async (userId: string) => {
  return await fetcher<TGetStaffBasicInfoRes, any>(
    ENDPOINT.USER.GET_STAFF_BASIC_INFO,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_STAFF_BASIC_INFO.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetStaffBasicInfo = async (userId: string) => {
  return (await getStaffBasicInfo(userId)).data;
};

queryGetStaffBasicInfo._key = (userId: string) => [
  ENDPOINT.USER.GET_STAFF_BASIC_INFO.url,
  userId,
];
